import { getDynamicComponentsFromRenderingData, getPlaceholderDataFromRenderingData, } from '../components/PlaceholderCommon';
/**
 * @param {Vue} vm
 * @param {ComponentFactory} [componentFactory]
 */
export function providePlaceholders(vm, componentFactory) {
    const instanceOptions = vm.$options;
    const propsData = vm.$props;
    if (typeof instanceOptions.withPlaceholder === 'undefined' ||
        typeof propsData === 'undefined' ||
        typeof propsData.rendering === 'undefined') {
        return;
    }
    // Initialize the computed option if it hasn't already been initialized.
    if (typeof vm.$options.computed === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        vm.$options.computed = {};
    }
    const { placeholders, options } = typeof instanceOptions.withPlaceholder === 'function'
        ? instanceOptions.withPlaceholder()
        : instanceOptions.withPlaceholder;
    const renderingData = propsData.rendering;
    const definitelyArrayPlaceholders = !Array.isArray(placeholders) ? [placeholders] : placeholders;
    const computedProps = definitelyArrayPlaceholders.reduce((result, placeholderDefinition) => {
        const placeholderName = placeholderDefinition.placeholder
            ? placeholderDefinition.placeholder
            : placeholderDefinition;
        const computedPropName = placeholderDefinition.computedPropName
            ? placeholderDefinition.computedPropName
            : placeholderDefinition;
        const placeholderData = getPlaceholderDataFromRenderingData(renderingData, placeholderName);
        if (placeholderData) {
            Object.defineProperty(result, computedPropName, {
                get: function () {
                    return getDynamicComponentsFromRenderingData(placeholderData, Object.assign(Object.assign({}, propsData), vm.$attrs), (options && options.componentFactory) || componentFactory);
                },
                enumerable: true,
            });
        }
        return result;
    }, {});
    vm.$options.computed = Object.assign(Object.assign({}, vm.$options.computed), computedProps);
}
